
import { defineComponent, PropType } from 'vue';


const BuilderPushContent = defineComponent({
  name: 'BuilderPushContent',
  props: {
    alignment: {
      type: String as PropType<'left' | 'right'>,
      default: 'left',
    },
    titleTag: {
      type: String,
      default: 'h2'
    },
    /** Title */
    title: {
      type: String,
      default: null,
    },
    /** Text */
    text: {
      type: String,
      default: null,
    },
    /** Image */
    image: {
      type: Object,
      default: null,
    },
    /** CTAS LIST */
    ctas: {
      type: Object as PropType<Link[]>,
      default: null,
    },
    squareFormat: {
      type: Boolean,
      default: false
    }
  },
});
export default BuilderPushContent
